import { useSelector } from 'react-redux'
import DragBoard from './DragBoard'

const Dashboard = () => {
  const scaledDashboard = useSelector((state) => state.auth.scaledDashboard)

  return <DragBoard disableCursor={true} scaled={scaledDashboard} />
}

export default Dashboard
